document.addEventListener('DOMContentLoaded', function () {
  var maxHeight = 200;

  document.querySelectorAll('.product__description').forEach(function (desc) {
    if (desc.scrollHeight <= maxHeight) return;

    desc.style.maxHeight = maxHeight + 'px';
    desc.style.overflow = 'hidden';
    desc.style.position = 'relative';

    var fade = document.createElement('div');
    fade.style.cssText = 'position:absolute;bottom:0;left:0;right:0;height:60px;background:linear-gradient(transparent,var(--color-background,#fff));pointer-events:none;';
    desc.appendChild(fade);

    var btn = document.createElement('button');
    btn.textContent = 'Lees meer';
    btn.style.cssText = 'display:block;margin:8px 0 0;background:none;border:none;padding:0;color:var(--color-foreground,#333);font-size:0.9em;text-decoration:underline;cursor:pointer;';
    desc.insertAdjacentElement('afterend', btn);

    btn.addEventListener('click', function () {
      if (desc.style.maxHeight !== 'none') {
        desc.style.maxHeight = 'none';
        desc.style.overflow = 'visible';
        fade.style.display = 'none';
        btn.textContent = 'Lees minder';
      } else {
        desc.style.maxHeight = maxHeight + 'px';
        desc.style.overflow = 'hidden';
        fade.style.display = 'block';
        btn.textContent = 'Lees meer';
        desc.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});
